<div class="splash-screen">
  <div class="bx--grid">
    <div class="bx--row">
      <div class="bx--col-xlg-6 bx--col-lg-4 bx--col-md-4 bx--col-sm">
        <img
          class="logo"
          src="../../../../assets/images/IDS-Logo.png"
          alt="IDS - logo"
          />
        </div>
      </div>
    </div>
    <div class="bx--grid">
      <div class="bx--row">
        <div class="bx--col-xlg-6 bx--col-lg-7 bx--col-md-7 bx--col-sm">
          <app-message
            [messages]="messages"
            data-qa="messages"
            >
          </app-message>
        </div>
      </div>
    </div>
    <div class="bx--grid">
      <div class="bx--row">
        <div class="bx--col-xlg-3 bx--col-lg-4 bx--col-md-4 bx--col-sm">
          <h1 data-qa="heading">{{ heading }}</h1>
          <div class="bx--form-item-control authentication-code-label">
            <strong data-qa="subheading">
              {{ subheading }}
            </strong>
          </div>
          <form
            class="form-mt"
            [formGroup]="authenticationForm"
            >
            <div class="bx--form-item-control">
              <app-input-text
                autocomplete="off"
                data-qa="authentication-code-input"
                displayName="Code"
                inputId="authentication-code"
                label="{{ challengeName === MfaType.SMS_MFA ? 'SMS Code' : 'Authenticator Code' }}"
                name="code"
                theme="dark"
                [focusOnLoad]="true"
                [formGroup]="authenticationForm"
                [maxLength]="maxLength"
              ></app-input-text>
            </div>

            <div class="bx--form-item-control">
              @if (!isProcessing) {
                <app-button
                  data-qa="verify-button"
                  [isDisabled]="authenticationForm.status === 'INVALID'"
                  buttonLabel="Continue"
                  buttonIcon="pi pi-arrow-right"
                  (buttonClicked)="verify()"
                  type="submit"
                  buttonId="verify-submit"
                  class="full-width"
                ></app-button>
              }
            </div>
            <div class="bx--form-item-control">
              @if (isProcessing) {
                <img
                  data-qa="spinner-image"
                  class="spinner p-mt-2"
                  alt="spinning icon showing indicating form is loading"
                  src="../../../assets/images/spinner.svg"
                  />
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
